import { Component, EventEmitter, Input, Output } from '@angular/core';

// Panel de control (sin lógica de canvas) para curvar una selección múltiple arbitraria de
// objetos en circular/elíptica/parabólica. Puramente presentacional: todo el estado vive en
// generate-canvas.component.ts, que reacciona a cada evento recalculando el layout en vivo.
@Component({
  selector: 'app-curve-selection-panel',
  templateUrl: './curve-selection-panel.component.html'
})
export class CurveSelectionPanelComponent {

  @Input() mode: 'circular' | 'elliptical' | 'parabolic' = 'circular';
  @Input() placingCenter: boolean = false;
  @Input() radius: number = 0;
  @Input() arcDeg: number = 60;
  @Input() ellipseAspect: number = 1;
  @Input() ellipseRotation: number = 0;
  @Input() curvature: number = 0;
  @Input() invert: boolean = false;

  @Output() modeChange = new EventEmitter<'circular' | 'elliptical' | 'parabolic'>();
  @Output() togglePlacingCenter = new EventEmitter<void>();
  @Output() radiusChange = new EventEmitter<number>();
  @Output() arcDegChange = new EventEmitter<number>();
  @Output() ellipseAspectChange = new EventEmitter<number>();
  @Output() ellipseRotationChange = new EventEmitter<number>();
  @Output() curvatureChange = new EventEmitter<number>();
  @Output() invertChange = new EventEmitter<void>();
  @Output() apply = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  setMode(mode: 'circular' | 'elliptical' | 'parabolic') {
    if (mode === this.mode) return;
    this.mode = mode;
    this.modeChange.emit(mode);
  }
}
